// Observed image zoom behavior, without source scripts or a carousel dependency.
(() => {
  if (window.sbGalleryLoaded) return;
  window.sbGalleryLoaded = true;
  const desktop = () => matchMedia('(min-width:750px)').matches;
  const setScale = (wrap, scale, x, y) => {
    const rect = wrap.getBoundingClientRect(), previous = Number(wrap.dataset.scale || 1);
    scale = Math.max(1, Math.min(4, scale));
    const tx = Number(wrap.dataset.tx || 0) - ((x - rect.left - rect.width / 2 - Number(wrap.dataset.tx || 0)) / previous) * (scale - previous);
    const ty = Number(wrap.dataset.ty || 0) - ((y - rect.top - rect.height / 2 - Number(wrap.dataset.ty || 0)) / previous) * (scale - previous);
    wrap.dataset.scale = scale;wrap.dataset.tx = tx;wrap.dataset.ty = ty;apply(wrap);
  };
  const apply = wrap => {
    const scale = Number(wrap.dataset.scale || 1), rect = wrap.getBoundingClientRect();
    const maxX = (scale - 1) * rect.width / 2, maxY = (scale - 1) * rect.height / 2;
    wrap.dataset.tx = Math.max(-maxX, Math.min(maxX, Number(wrap.dataset.tx || 0)));
    wrap.dataset.ty = Math.max(-maxY, Math.min(maxY, Number(wrap.dataset.ty || 0)));
    wrap.querySelector('img').style.transform = `translate3d(${wrap.dataset.tx}px,${wrap.dataset.ty}px,0) scale(${scale})`;
    wrap.classList.toggle('is-zoomed', scale > 1.01);
    wrap.closest('product-lightbox').classList.toggle('is-slide-zoomed', scale > 1.01);
  };
  const reset = wrap => {wrap.dataset.scale = 1;wrap.dataset.tx = 0;wrap.dataset.ty = 0;apply(wrap);};
  class Lightbox extends HTMLElement {
    connectedCallback() {
      if (this.sbReady) return;this.sbReady = true;
      this.querySelector('.product-lightbox__dialog').tabIndex = -1;
      this.slides = [...this.querySelectorAll('.product-lightbox__slide')];
      const dots = this.querySelector('.product-lightbox__dots');dots.removeAttribute('aria-hidden');
      this.slides.forEach((slide, index) => {
        const button = document.createElement('button');button.type = 'button';button.className = 'product-lightbox__dot';
        button.setAttribute('aria-label', `Go to slide ${index + 1}`);button.dataset.sbLightboxSlide = index;dots.append(button);
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (event.target.matches('.product-lightbox__backdrop') || button?.matches('.product-lightbox__close')) this.close();
        else if (button?.matches('.product-lightbox__arrow')) this.select(this.index + (button.classList.contains('product-lightbox__arrow--next') ? 1 : -1));
        else if (button?.hasAttribute('data-sb-lightbox-slide')) this.select(Number(button.dataset.sbLightboxSlide));
      });
      this.addEventListener('keydown', event => {
        if(event.key === 'Escape'){event.preventDefault();this.close();}
        if(event.key === 'ArrowLeft' || event.key === 'ArrowRight'){event.preventDefault();this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1));}
        if(event.key === 'Tab'){
          const controls = [...this.querySelectorAll('button')].filter(n => !n.disabled && n.getBoundingClientRect().width);
          const first = controls[0], last = controls.at(-1);
          if(event.shiftKey && (document.activeElement === first || document.activeElement === this.querySelector('[role=dialog]'))){event.preventDefault();last.focus();}
          else if(!event.shiftKey && document.activeElement === last){event.preventDefault();first.focus();}
        }
      });
      for(const wrap of this.querySelectorAll('[data-zoomable]')){
        const pointers = new Map();let start, moved = false, lastTap = 0;
        wrap.addEventListener('wheel', event => {
          if(!event.ctrlKey && !event.metaKey)return;event.preventDefault();
          setScale(wrap, Number(wrap.dataset.scale || 1) * (1 - event.deltaY * .01), event.clientX, event.clientY);
        }, {passive:false});
        wrap.addEventListener('pointerdown', event => {
          pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});wrap.setPointerCapture(event.pointerId);moved = false;
          start = {x:event.clientX,y:event.clientY,tx:Number(wrap.dataset.tx || 0),ty:Number(wrap.dataset.ty || 0),scale:Number(wrap.dataset.scale || 1)};
          if(pointers.size === 2){const [a,b] = [...pointers.values()];start.distance = Math.hypot(a.x-b.x,a.y-b.y);}
        });
        wrap.addEventListener('pointermove', event => {
          if(!pointers.has(event.pointerId))return;
          pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
          if(Math.hypot(event.clientX-start.x,event.clientY-start.y)>5)moved = true;
          if(pointers.size === 2 && start.distance){
            const [a,b] = [...pointers.values()];setScale(wrap, start.scale*Math.hypot(a.x-b.x,a.y-b.y)/start.distance,(a.x+b.x)/2,(a.y+b.y)/2);
          }else if(Number(wrap.dataset.scale || 1)>1){wrap.dataset.tx=start.tx+event.clientX-start.x;wrap.dataset.ty=start.ty+event.clientY-start.y;apply(wrap);}
        });
        const release = event => {
          const pinching = pointers.size>1;pointers.delete(event.pointerId);
          if(event.type !== 'pointercancel' && !moved && !pinching && (event.pointerType === 'mouse' || Date.now()-lastTap<300)){
            setScale(wrap,Number(wrap.dataset.scale || 1)>1 ? 1 : 2.5,event.clientX,event.clientY);
          }else if(!pinching && Number(wrap.dataset.scale || 1)===1 && start && Math.abs(event.clientX-start.x)>40){
            this.select(this.index+(event.clientX<start.x?1:-1));
          }
          if(pinching)moved=true;lastTap=Date.now();
        };
        wrap.addEventListener('pointerup',release);wrap.addEventListener('pointercancel',release);
      }
    }
    select(index){
      this.index = Math.max(0, Math.min(this.slides.length-1,index));
      this.slides.forEach((slide,position)=>{
        slide.hidden = position!==this.index;slide.inert = slide.hidden;
        slide.setAttribute('aria-hidden',String(slide.hidden));
        for(const wrap of slide.querySelectorAll('[data-zoomable]'))reset(wrap);
      });
      this.querySelectorAll('.product-lightbox__dot').forEach((dot,position)=>{dot.classList.toggle('is-active',position===this.index);dot.setAttribute('aria-current',String(position===this.index));});
    }
    open(mediaId,opener){
      this.opener = opener;this.hidden = false;
      this.select(Math.max(0,this.slides.findIndex(slide=>slide.dataset.mediaId===mediaId)));
      document.body.classList.add('sb-lightbox-open');
      this.previousInert = [...document.body.children].filter(node=>!node.contains(this)).map(node=>[node,node.inert]);
      this.previousInert.forEach(([node])=>{node.inert=true;});this.querySelector('.product-lightbox__close').focus();
    }
    close(){
      this.hidden=true;document.body.classList.remove('sb-lightbox-open');
      this.previousInert?.forEach(([node,previous])=>{node.inert=previous;});
      this.querySelectorAll('[data-zoomable]').forEach(reset);this.opener?.focus();
    }
    disconnectedCallback(){if(!this.hidden)this.close();}
  }
  class HoverZoom extends HTMLElement {
    connectedCallback(){
      if(this.sbReady)return;this.sbReady=true;
      this.addEventListener('pointermove',event=>{
        if(event.pointerType!=='mouse'||!desktop())return;
        const image=this.querySelector('img'),rect=this.getBoundingClientRect();if(!image)return;
        this.classList.add('product-hover-zoom--inline-active');image.style.transition='transform .05s linear';
        image.style.transformOrigin=`${(event.clientX-rect.left)/rect.width*100}% ${(event.clientY-rect.top)/rect.height*100}%`;image.style.transform='scale(2.5)';
      });
      this.addEventListener('pointerleave',()=>{this.classList.remove('product-hover-zoom--inline-active');const image=this.querySelector('img');if(image){image.style.transform='';image.style.transformOrigin='';image.style.transition='';}});
    }
  }
  if(!customElements.get('product-lightbox'))customElements.define('product-lightbox',Lightbox);
  if(!customElements.get('product-hover-zoom'))customElements.define('product-hover-zoom',HoverZoom);
  const open = (gallery,slide,opener) => {
    if(!slide?.classList.contains('is-active')||!slide.querySelector('img')||slide.classList.contains('product__media-item--full'))return;
    if(!(desktop()?['lightbox','combined'].includes(gallery.dataset.zoomDesktop):gallery.dataset.zoomMobile==='lightbox'))return;
    document.getElementById('ProductLightbox-'+gallery.dataset.section)?.open(slide.dataset.mediaId,opener);
  };
  const init = event => (event?.target || document).querySelectorAll('media-gallery').forEach(gallery=>{
    const enabled=desktop()?['lightbox','combined'].includes(gallery.dataset.zoomDesktop):gallery.dataset.zoomMobile==='lightbox';
    gallery.querySelectorAll('.product__modal-opener').forEach(opener=>{
      if(enabled){opener.tabIndex=0;opener.setAttribute('role','button');opener.setAttribute('aria-label','Open image gallery');}
      else{opener.removeAttribute('tabindex');opener.removeAttribute('role');opener.removeAttribute('aria-label');}
    });
  });
  document.addEventListener('click',event=>{const slide=event.target.closest('media-gallery .product__media-item');if(slide)open(slide.closest('media-gallery'),slide,slide.querySelector('.product__modal-opener'));});
  document.addEventListener('keydown',event=>{
    const opener=event.target.closest('media-gallery .product__modal-opener[role=button]');
    if(opener&&(event.key==='Enter'||event.key===' ')){event.preventDefault();open(opener.closest('media-gallery'),opener.closest('.product__media-item'),opener);}
  });
  document.addEventListener('shopify:section:load',init);window.addEventListener('resize',()=>init());init();
})();
